import ApplicationConfigurationPage from './application-configuration-page';

export default ApplicationConfigurationPage;